import React, { useState } from "react";
import Header from "./Header";

export default function UnliftedPieces() {
  const [manualSelect, setManualSelect] = useState(false);

  return (
    <div style={styles.pageContainer}>
      <Header title="Unlifted Pieces" />

      <div style={styles.card}>
        {/* Manual Selection */}
        <div style={styles.checkboxGroup}>
          <input
            type="checkbox"
            checked={manualSelect}
            onChange={() => setManualSelect(!manualSelect)}
          />
          <label style={styles.checkboxLabel}>Manual Selection</label>
        </div>

        {/* Shipper ID */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Shipper ID</label>
          {manualSelect ? (
            <select style={styles.select}>
              <option value="">Select Shipper ID</option>
            </select>
          ) : (
            <input type="text" placeholder="Scan Shipper ID" style={styles.input} />
          )}
        </div>

        {/* Shipper Name */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Shipper Name</label>
          <input type="text" disabled placeholder="Auto-filled" style={styles.input} />
        </div>

        {/* SKU */}
        <div style={styles.formGroup}>
          <label style={styles.label}>SKU</label>
          <select style={styles.select}>
            <option value="">Select SKU</option>
          </select>
        </div>

        {/* ASN Number */}
        <div style={styles.formGroup}>
          <label style={styles.label}>ASN Number</label>
          <input type="text" disabled placeholder="Auto-filled" style={styles.input} />
        </div>

        {/* Location */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Location ID</label>
          <input type="text" placeholder="Scan or Enter Location ID" style={styles.input} />
        </div>

        {/* Number of Pieces */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Number of Pieces</label>
          <input type="number" placeholder="Enter Pieces" style={styles.input} />
        </div>

        {/* Submit Button */}
        <div style={styles.formGroup}>
          <button style={styles.submitBtn}>Update</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: "100vh",
    background: "#f5f6fa",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    maxWidth: "700px",
    margin: "2rem auto",
    background: "#fff",
    padding: "2rem",
    borderRadius: "16px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
  },
  checkboxGroup: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1.5rem",
    gap: "0.5rem",
  },
  checkboxLabel: {
    fontWeight: "500",
    fontSize: "1rem",
  },
  formGroup: {
    marginBottom: "1.5rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    fontWeight: "600",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  select: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
    background: "#fff",
  },
  submitBtn: {
    width: "100%",
    padding: "1rem",
    backgroundColor: "#E30016",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};
